import { render } from "./Editor.vue?vue&type=template&id=4ee7aa3b"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=4ee7aa3b&lang=scss"
script.render = render

export default script